import { render, staticRenderFns } from "./CompanyTags.vue?vue&type=template&id=cf0f2c0c"
import script from "./CompanyTags.vue?vue&type=script&lang=js"
export * from "./CompanyTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports